import chevronDown from '@iconify/icons-carbon/chevron-down';
import chevronUp from '@iconify/icons-carbon/chevron-up';

import { Iconify } from '../Iconify';

import type { IconifyProps } from '../Iconify';
import type { FC } from 'react';

interface SubLinkProps extends Omit<IconifyProps, 'icon'> {
  isOpen?: boolean;
  icon?: IconifyProps['icon'];
}

export const Chevron: FC<SubLinkProps> = ({ isOpen, ...props }) => (
  <Iconify
    sx={{
      ml: 0.5,
      width: 16,
      height: 16,
    }}
    {...props}
    icon={isOpen ? chevronUp : chevronDown}
  />
);
